import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { windowInputOf } from 'shared/metrics-window'
import { trpc } from '@/main'

// Pathless layout that OWNS the platform screen's window-keyed reads, so a range switch re-keys THIS match and not the screen
// above it, which would repaint its skeleton. No component; the screen reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/admin/metrics/platform/_window')({
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  context: ({ deps }) => {
    const window = windowInputOf(deps)
    return {
      metricsGrowthQueryOptions: trpc.admin.metricsGrowth.queryOptions(window),
      metricsTrafficQueryOptions: trpc.admin.metricsTraffic.queryOptions(window),
    }
  },
  loader: ({ context }) => {
    context.queryClient.query(context.metricsGrowthQueryOptions).catch(noop)
    context.queryClient.query(context.metricsTrafficQueryOptions).catch(noop)
  },
})
